import { useEffect, useState } from 'react';

import { openSupportForm } from 'store/user/actions';

import { ONGOING_EXPERIMENTS } from 'constants/eppo';

import { sendAnalyticSideBarElementClick } from 'services/Analytics';
import { ActionEventAction } from 'services/Analytics/core';
import { getAbTestName } from 'services/Analytics/helpers';
import { useFeatureFlagWithAQA } from 'services/Eppo';

import { useDispatch } from 'hooks/store';

const useContactUsAction = (closeSidebar: () => void) => {
    const dispatch = useDispatch();
    const [chatIsVisible, setChatIsVisible] = useState<boolean>(false);

    const {
        value: { visible },
    } = useFeatureFlagWithAQA<{ visible: boolean }>({
        type: 'json',
        flagKey: ONGOING_EXPERIMENTS.ContactUsChat,
        defaultValue: { visible: false },
    });

    useEffect(() => {
        setChatIsVisible(visible);
    }, [visible]);

    const onClickContactUs = () => {
        sendAnalyticSideBarElementClick(ActionEventAction.contactUs, {
            ab_test_name: getAbTestName({
                experiment: ONGOING_EXPERIMENTS.ContactUsChat,
                variantName: chatIsVisible ? 'visible' : 'invisible',
            }),
        });

        closeSidebar();

        dispatch(openSupportForm({ chatIsVisible }));
    };

    return { onClickContactUs };
};

export { useContactUsAction };
